import React, { Fragment } from 'react';
import Button from '../../../../components/Button';
import BaseForm from '../../../../components/form/BaseForm';
import InputForm from '../../../../components/form/InputForm';
import RadioGroupForm from '../../../../components/form/RadioGroupForm';
import SelectForm from '../../../../components/form/SelectForm';
import ImgUpload from '../../../../components/ImgUpload/ImgUpload';
import Panel from '../../../../components/outline/Panel';
import EditableTagGroup from '../../../../components/tag/EditableTagGroup';
import RecommendTag from '../../../../components/tag/RecommendTag';
import {
  MAXIMUM_NUMBER_OF_TAG_NAME,
  MINIMUM_HEIGHT_OF_INPUT_TAG_THUMBNAIL_IMG,
  MINIMUM_WIDTH_OF_INPUT_TAG_THUMBNAIL_IMG,
  TAG_EDIT_PAGE_PANEL_NAME,
  TAG_STATUS,
  TAG_EDIT_STATUS_SELECT_LIST,
  TAG_THUMBNAIL_IMG_HEIGHT,
  TAG_THUMBNAIL_IMG_WIDTH,
} from '../../../../constants/service/app/tagConstants';
import { TAG_GROUP_CREATE_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { openNewWindow } from '../../../../lib/common';
import { formRequiredRules } from '../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../constants/service/common/formRulesConstants';
import { IMAGE_SIZE_GUIDE_TEXT, IMAGE_TYPE_GUIDE_TEXT } from '../../../../constants/service/common/commonConstants';
import './TagEditInfo.scss';

const TagEditInfo = (props) => {
  const {
    form,
    tagInfo,
    tagSearchSelectList,
    tagGroupSelectList,
    recommendTagSelectList,
    setData,
    onChangeTagName,
    getTagSearchList,
    selectRecommendTag,
    getRecommendTagList,
  } = props;

  return (
    <Panel name={TAG_EDIT_PAGE_PANEL_NAME.TAG_EDIT_INFO} className="tag-edit-info">
      <div className="panel-header">
        <div className="title">태그 정보</div>
      </div>

      <div className="panel-body">
        {/* 태그명*/}
        <InputForm
          label="태그명"
          form={form}
          className="tag-name"
          rules={[formRequiredRules(true, REQUIRED_MSG)]}
          initialValue={tagInfo.tagName}
          maxLength={MAXIMUM_NUMBER_OF_TAG_NAME}
          onChange={(value) => onChangeTagName(value)}
          name="tagName"
          subContent={
            <div className="sub-info">
              {tagInfo.isDuplicationTagName ? <div className="input-warning">이미 등록된 태그명입니다.</div> : null}
              <div>*태그명은 한글, 영문 소문자, 숫자만 가능하며 최대 13자리까지 입력 가능합니다.</div>
            </div>
          }
        />

        {/*태그 상태*/}
        {tagInfo.status !== TAG_STATUS.confirmReady ? (
          <BaseForm
            label="태그 상태"
            content={
              <Fragment>
                <RadioGroupForm
                  form={form}
                  disabled={!tagInfo.tagId}
                  initialValue={tagInfo.status}
                  onChange={(value) =>
                    setData({
                      path: ['tagEdit', 'tagInfo', 'status'],
                      value,
                    })
                  }
                  list={TAG_EDIT_STATUS_SELECT_LIST}
                  name="tagStatus"
                />
              </Fragment>
            }
            subContent={
              <div className="sub-info">
                <div>
                  * 태그 상태를 비활성 하면 연결된 브랜드, 상품, 상품 후기, 기획전, 추천 태그에서 해당 태그가 노출이
                  되지 않습니다.
                </div>
              </div>
            }
          />
        ) : null}

        {/* 태그 그룹*/}
        <SelectForm
          label="태그 그룹"
          form={form}
          className="tag-group-select-list"
          name="tagGroup"
          list={tagGroupSelectList}
          initialValue={tagInfo.tagGroupIdList}
          mode="multiple"
          isTable={true}
          onChange={(value) =>
            setData({
              path: ['tagEdit', 'tagInfo', 'tagGroupIdList'],
              value,
            })
          }
          subContent={
            <Button
              isRadius
              color="primary"
              text="태그 그룹 추가하기"
              onClick={() => openNewWindow(TAG_GROUP_CREATE_URL_PATH)}
            />
          }
        />

        {/* 연관된 태그 */}
        <BaseForm
          className="related-tag-select-list"
          label="연관된 태그"
          content={
            <Fragment>
              <EditableTagGroup
                form={form}
                name="relatedTagList"
                selectedTagList={tagInfo.relatedTagList}
                tagSearchSelectList={tagSearchSelectList}
                getTagSearchList={getTagSearchList}
                onChange={(value) =>
                  setData({
                    path: ['tagEdit', 'tagInfo', 'relatedTagList'],
                    value,
                  })
                }
                closable={true}
              />

              <div className="help-text">
                <div>* 연관된 태그는 최소 3개 이상입니다.</div>
              </div>

              <RecommendTag
                getRecommendTagList={() =>
                  getRecommendTagList({
                    keyword: tagInfo.tagName,
                  })
                }
                summary={
                  <Fragment>
                    <div>* 입력하신 태그명과 비슷한 태그리스트입니다.</div>
                    <div>* 태그를 클릭하면 연관된 태그로 적용됩니다.</div>
                  </Fragment>
                }
                recommendTagSelectList={recommendTagSelectList}
                selectRecommendTag={selectRecommendTag}
                notRecommendListMessage="입력하신 태그명에 추천할 태그가 존재하지 않습니다."
              />
            </Fragment>
          }
        />

        {/* 태그 이미지*/}
        <BaseForm
          label="태그 이미지"
          content={
            <ImgUpload
              list={tagInfo.tagImg}
              modalTitle="태그 이미지"
              // maxCnt={MAXIMUM_NUMBER_OF_WIDGET_DETAIL_TOP_IMG}
              setData={setData}
              targetPath={['tagEdit', 'tagInfo', 'tagImg']}
              targetSize={{
                width: TAG_THUMBNAIL_IMG_WIDTH,
                height: TAG_THUMBNAIL_IMG_HEIGHT,
              }}
              restriction={{
                widthMin: MINIMUM_WIDTH_OF_INPUT_TAG_THUMBNAIL_IMG,
                heightMin: MINIMUM_HEIGHT_OF_INPUT_TAG_THUMBNAIL_IMG,
              }}
              cropMode={true}
              isProductAttachment={true}
            />
          }
          subContent={
            <div className="sub-info">
              <div>*태그 이미지를 선택하지 않으면 기본 이미지로 저장하게 됩니다.</div>
              <div>*비율 가로1:세로1</div>
              <div>*권장 크기: 500 x 500 px(권장 크기보다 작을 경우, 앱에서 화질 저하의 우려가 있습니다.)</div>
              <div>*{IMAGE_SIZE_GUIDE_TEXT}</div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
            </div>
          }
        />
      </div>
    </Panel>
  );
};

export default TagEditInfo;
